import { c as _c } from "react/compiler-runtime";
import { useMemo } from 'react';
import { BrowseCourse } from '@udemy-v2/browse-course';
import { TrackableDiscoveryItem } from '@udemy-v2/react-browse-event-tracking';
import { RecommendationItem, RecommendationUnit, useRecommendationsSections } from '@udemy-v2/react-recommendations';
import { ResponsiveBrowseCourseCarousel } from '@/features/course-landing-page/components/browse-course-carousel/responsive-browse-course-carousel.react-component';
import styles from './limited-access-recommendations-carousel.module.scss';
import { CAROUSEL_CONFIGURATIONS } from "@udemy-v2/react-browse-course";
const sectionToUnits = (section: ReturnType<typeof useRecommendationsSections>['data'][number]): RecommendationUnit[] => {
  if ('units' in section) return section.units;
  if ('items' in section) return [section];
  return [];
};
const unitToCourses = (unit: RecommendationUnit): TrackableDiscoveryItem<BrowseCourse>[] => {
  const courses: TrackableDiscoveryItem<BrowseCourse>[] = [];
  unit.items.forEach((item: RecommendationItem) => {
    if (item && typeof item === 'object' && 'course' in item && item.course) {
      courses.push({
        ...(item.course as BrowseCourse),
        trackingId: item.trackingId,
        frontendTrackingId: item.frontendTrackingId
      });
    }
  });
  return courses;
};

/**
 * Reads recommendation sections fro
 * m the surrounding RecommendationsProvider
 * (see [[LimitedAccessRecommendationsWrapper]]) and renders one
 * `ResponsiveBrowseCourseCarousel` per returned recommendation unit. Renders nothing
 * while loading or when no unit returned a course list.
 */
export const LimitedAccessRecommendationsCarousel = () => {
  const $ = _c(7);
  const {
    data: sections,
    status
  } = useRecommendationsSections();
  let t0;
  bb0: {
    if (status === "loading" || sections.length === 0) {
      let t1;
      if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = [];
        $[0] = t1;
      } else {
        t1 = $[0];
      }
      t0 = t1;
      break bb0;
    }
    let t1;
    if ($[1] !== sections) {
      t1 = sections.flatMap(sectionToUnits).map(_temp).filter(_temp2);
      $[1] = sections;
      $[2] = t1;
    } else {
      t1 = $[2];
    }
    t0 = t1;
  }
  const carousels = t0;
  if (status === "loading" || carousels.length === 0) {
    return null;
  }
  let t1;
  if ($[3] !== carousels) {
    t1 = carousels.map(_temp3);
    $[3] = carousels;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== t1) {
    t2 = <div className={styles.container}>{t1}</div>;
    $[5] = t1;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return t2;
};
function _temp(unit) {
  return {
    id: unit.id,
    title: unit.title,
    courses: unitToCourses(unit)
  };
}
function _temp2(unit_0) {
  return unit_0.courses.length > 0;
}
function _temp3(t0) {
  const {
    id,
    title,
    courses
  } = t0;
  return <section key={id} className={styles.unit}>{title && <h2 className="ud-heading-xl">{title}</h2>}<ResponsiveBrowseCourseCarousel courses={courses} config={CAROUSEL_CONFIGURATIONS.CARDS_4_COLUMNS} /></section>;
}